(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function getProductInfoFromTarget(target) {
    return target.closest('product-info');
  }

  function getMediaGallery(sectionId) {
    return document.querySelector(`#MediaGallery-${sectionId}`);
  }

  function getSelectedColor(productInfo) {
    if (!productInfo) return '';

    const fieldsets = Array.from(productInfo.querySelectorAll('variant-selects fieldset'));
    const colorFieldset = fieldsets.find((fieldset) => {
      const optionName = normalize(fieldset.getAttribute('data-option-name'));
      return optionName === 'color' || optionName === 'colour' || optionName === 'couleur';
    });

    if (!colorFieldset) return '';

    const checked = colorFieldset.querySelector('input[type="radio"]:checked');
    return checked ? normalize(checked.value) : '';
  }

  function filterGallery(sectionId) {
    const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
    if (!productInfo) return;

    const selectedColor = getSelectedColor(productInfo);
    if (!selectedColor) return;

    const mediaGallery = getMediaGallery(sectionId);
    if (!mediaGallery) return;

    const viewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const slides = Array.from(viewer.querySelectorAll('li[data-media-id]'));
    if (!slides.length) return;

    const matchedSlides = [];

    slides.forEach((slide) => {
      const alt = normalize(slide.getAttribute('data-alt'));
      const isMatch = alt === selectedColor;

      slide.style.display = isMatch ? '' : 'none';
      slide.classList.remove('is-active');

      if (isMatch) matchedSlides.push(slide);
    });

    const thumbnailTriggers = mediaGallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]');
    thumbnailTriggers.forEach((trigger) => {
      const mediaId = trigger.getAttribute('data-target');
      const linkedSlide = viewer.querySelector(`li[data-media-id="${mediaId}"]`);
      const thumbItem = trigger.closest('li');

      if (!thumbItem) return;

      thumbItem.style.display =
        linkedSlide && linkedSlide.style.display !== 'none' ? '' : 'none';
    });

    if (matchedSlides.length) {
      const firstVisible = matchedSlides[0];
      const firstVisibleId = firstVisible.getAttribute('data-media-id');

      firstVisible.classList.add('is-active');

      if (typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(firstVisibleId, false);
      }
    }
  }

  function onVariantChange(event) {
    const target = event.target;
    if (!target || !target.matches('variant-selects input[type="radio"], variant-selects select')) return;

    const productInfo = getProductInfoFromTarget(target);
    if (!productInfo) return;

    const sectionId = productInfo.dataset.section;
    if (!sectionId) return;

    setTimeout(() => {
      filterGallery(sectionId);
    }, 150);
  }

  function init() {
    document.addEventListener('change', onVariantChange);

    document.querySelectorAll('product-info[data-section]').forEach((productInfo) => {
      filterGallery(productInfo.dataset.section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();